// extracted by mini-css-extract-plugin
module.exports = {"GameBoard":"GameBoard_GameBoard__WKpaQ"};